<!-- <div class="list-container">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Distributor List</h4>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Phone Number</th>
                    <th scope="col">Email</th>
                    <th scope="col">Address</th>
                    <th scope="col">Action</th>

                </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let list of distributorList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        };let i = index">
                        <th scope="col">{{list.name}}</th>
                        <td scope="col">{{list.phNo}}</td>
                        <td scope="col">{{list.email}}</td>
                        <td scope="col">{{list.address}}</td>
                        <td>
                            <i class="bi bi-eye" data-toggle="modal" data-target="#view" (click)="getIdistributorById(list.idistributorId)"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="pagination-block" *ngIf="distributorList.length != 0">
                <pagination-controls
                    previousLabel="Prev"
                    nextLabel="Next"
                    (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
            </div>
        </div>
    </div>
</div> -->

<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
          
              <div class="header-block">
                  <div class="header-title">
          <app-breadcrumb></app-breadcrumb>
                  </div>
                  <div class="add-block">
                    <select class="form-control" [(ngModel)]="idistributorId">
                        <option value="" disabled selected hidden> -- select distributor -- </option>
                        <option *ngFor="let list of distributorList" value="{{list.idistributorId}}">{{list.name}}</option>
                    </select>
                    <button (click)="getIDealerByDistributorId(0,10)"> search</button>
                  </div>
              </div>

              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 20%;">Name</th>
                        <th style="width: 20%;">Phone Number</th>
                        <th style="width: 20%;">Email</th>
                        <th style="width: 15%;">Address</th>
                        <th style="width: 15%;">Status</th>

                        <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let list of dealerList | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    };let i = index">
                    <p style="width: 20%;">{{list.name}}</p>
                    <p style="width: 20%;">{{list.phNo}}</p>
                    <p style="width: 20%;">{{list.email}}</p>
                    <p style="width: 15%;">{{list.address}}</p>
                    <p style="width: 15%;">{{list.latestStatus}}</p>

                  
                      <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                          <!-- <i class="bi bi-pencil-square" (click)="getBillingTermById(term.billingTermId)" data-toggle="modal" data-target="#editModal" ></i> -->
                          <i class="bi  bi-eye-fill" data-toggle="modal" data-target="#view" (click)="getIDealerById(list.idealerId)"></i>

                          <i *ngIf="actionControls.isDelete" class="bi bi-trash" (click)="selectIdealer(list.id)" data-toggle="modal" data-target="#deleteModal"></i>

                      </p>
                  </div>
              </div>


              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>

              <div class="loader"  *ngIf="!isLoading && dealerList.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>

              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                  [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                  </p-paginator>
              </div>


          </div>
  
        </div>
    </div>
</div>
    

<div class="modal fade" id="view" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Dealer Details 
            <span data-dismiss="modal">
                <i data-dismiss="modal" class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body" *ngFor="let list of singleIDealerData">
            <div class="form-group">
                <div class="row">
                    <div class="col-md-3 col-lg-3 details">
                        <label>Name</label>
                        <p>{{list.name}}</p>
                    </div>
                    <div class="col-md-3 col-lg-3 details">
                        <label>Phone No</label>
                        <p>{{list.phNo}}</p>
                    </div>
                    <div class="col-md-3 col-lg-3 details">
                        <label>Email</label>
                        <p>{{list.email}}</p>
                    </div>
                    <div class="col-md-3 col-lg-3 details">
                        <label>Address</label>
                        <p>{{list.address}}</p>
                    </div>
                    <div class="col-md-4 col-lg-4 details">
                        <label>addressProofUrl</label>
                        <div class="image-block">
                            <img src="{{list.addressProofUrl}}" alt="">
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 details">
                        <label>idProofUrl</label>
                        <div class="image-block">
                            <img src="{{list.idProofUrl}}" alt="">
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 details">
                        <label>photoUrl</label>
                        <div class="image-block">
                            <img src="{{list.photoUrl}}" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button *ngIf="list.latestStatus == 'VERIFIED'" type="button" id="" (click)="idealerUpdateStatus('REJECTED')" class="btn btn-primary">Reject</button>
                <button *ngIf="list.latestStatus == 'VERIFIED'" type="button" id="" (click)="idealerUpdateStatus('APPROVED')" class="btn btn-primary">Approve</button>
                <button type="button" id="closeAdd" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
      </div>
    </div>
  </div>




  <div class="modal fade" id="addModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Add Dealer
            <span data-dismiss="modal">
              <i data-dismiss="modal" class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body">
            <div class="row" [formGroup]="dealerForm">
                <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Name <span class="required-field">*</span></label>
                        <input type="text" formControlName="name" class="form-control">
                    </div>
                </div>
                <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Phone Number <span class="required-field">*</span></label>
                        <input type="text" formControlName="phNo" class="form-control">
                    </div>
                </div>
                <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Email <span class="required-field">*</span></label>
                        <input type="text" formControlName="email" class="form-control">
                    </div>
                </div>
                <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Distributor <span class="required-field">*</span></label>
                        <select class="form-control" formControlName="idistributorId">
                            <option *ngFor="let list of distributorList" value="{{list.idistributorId}}">{{list.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <label>Address <span class="required-field">*</span></label>
                        <textarea name="" formControlName="address" class="form-control" id="" cols="30" rows="3"></textarea>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12">
                    <div class="form-group add-image-btn">
                        <input type="file" #photoUrl
                        type="file" id="photoUrl"
                        accept="image/*" style="display: none;"
                        (change)="onUpload($event,'photoUrl')">
                        <button (click)="addImageBtn('photoUrl')" *ngIf="dealerForm.get('photoUrl').value == ''">Add Photo</button>
                        <div class="image-view" *ngIf="dealerForm.get('photoUrl').value != ''">
                            <label for="">Photo Proof <span class="remove" (click)="removeImage('photoUrl')">remove</span></label>
                            <img src="{{dealerForm.get('photoUrl').value}}" alt="">
                        </div>
                    </div>
    
                    <div class="form-group add-image-btn">
                        <input type="file" #idProofUrl
                        type="file" id="idProofUrl"
                        accept="image/*" style="display: none;"
                        (change)="onUpload($event,'idProofUrl')">
                        <button (click)="addImageBtn('idProofUrl')" *ngIf="dealerForm.get('idProofUrl').value == ''">Add Id Proof</button>
                        <div class="image-view" *ngIf="dealerForm.get('idProofUrl').value != ''">
                            <label for="">Id Proof <span class="remove" (click)="removeImage('idProofUrl')">remove</span></label>
                            <img src="{{dealerForm.get('idProofUrl').value}}" alt="">
                        </div>
                    </div>
    
                    <div class="form-group add-image-btn">
                        <input type="file" #addressProofUrl
                        type="file" id="addressProofUrl"
                        accept="image/*" style="display: none;"
                        (change)="onUpload($event,'addressProofUrl')">
                        <button (click)="addImageBtn('addressProofUrl')" *ngIf="dealerForm.get('addressProofUrl').value == ''">Add Address Proof</button>
                        <div class="image-view" *ngIf="dealerForm.get('addressProofUrl').value != ''">
                            <label for="">Address Proof <span class="remove" (click)="removeImage('addressProofUrl')">remove</span></label>
                            <img src="{{dealerForm.get('addressProofUrl').value}}" alt="">
                        </div>
                    </div>
                </div>
                
            </div> 
            <div class="modal-footer">
                <button type="button" id="closeAdd" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
  
                <button type="button" (click)="add()" class="btn btn-primary">Submit</button>
            </div>
        </div>
      </div>
    </div>
  </div>




<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Conformation!!
                <span data-dismiss="modal">
                    <i data-dismiss="modal" class="bi bi-x-lg"></i>
                </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>are you sure? want to delete??</p>   
                <div class="modal-footer">
                    <button type="button" id="closeDelete" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="deleteIdealer()" class="btn btn-primary">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>